export default __webpack_public_path__ + "static/media/bordspil.592e5058.jpg";